import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState, FilterOption, SortDropdownOption } from '@immosky/types';
import {
  availableSortOptions,
  selectSort,
  setSort,
} from '@immosky/object-search-filter';
import { connectedPositionsBottomRightPriority } from '@immosky/shared';

@Component({
  selector: 'app-sort-dropdown',
  templateUrl: './sort-dropdown.component.html',
  styleUrls: ['./sort-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortDropdownComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  isDropdownOpen = false;

  options = availableSortOptions;
  currentOption!: SortDropdownOption;

  overlayPositions: ConnectedPosition[] = connectedPositionsBottomRightPriority;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    const subscription = this.store
      .pipe(select(selectSort))
      .subscribe((option: SortDropdownOption) => {
        this.currentOption = option;
        this.cdRef.markForCheck();
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  toggleDropdown() {
    if (this.isDropdownOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isDropdownOpen = true;
    this.cdRef.markForCheck();
  }

  close() {
    window.requestAnimationFrame(() => {
      this.isDropdownOpen = false;
      this.cdRef.markForCheck();
    });
  }

  select(option: FilterOption) {
    this.store.dispatch(
      setSort({
        sort: option as SortDropdownOption,
      })
    );
    this.close();
  }
}
